import { createSelector, createStateHook, type HookStateFunction } from 'react-sweet-state';

import type { FieldMapInternalMetadata } from '../../../../common/types/field-internal-metadata';
import { store } from '../../main';
import type { IssueAdjustmentsState } from '../../types';

const selectFormMetadata = createSelector(
	(state: IssueAdjustmentsState) => state.internalFormMetadata,
	(metadata) => metadata,
);

export const useFormMetadata: HookStateFunction<FieldMapInternalMetadata, void> = createStateHook(
	store,
	{
		selector: selectFormMetadata,
	},
);
